if (
  typeof Uint8Array.fromBase64 !== 'function' ||
  typeof Uint8Array.prototype.toBase64 !== 'function'
) {
  await import('core-js/proposals/array-buffer-base64');
}

/**
 * Converts a base64 encoded string into an array of binary data.
 */
export function base64ToBytes(sBase64: string): Uint8Array {
  return Uint8Array.fromBase64(sBase64.replace(/[^A-Za-z0-9+/]/g, ''));
}

/**
 * Converts an array of binary data to a base64 encoded string.
 */
export function bytesToBase64(aBytes: Uint8Array): string {
  return aBytes.toBase64();
}

/**
 * Converts a base64url encoded string into an array of binary data.
 */
export function base64URLToBytes(sBase64URL: string): Uint8Array {
  let normalized = sBase64URL.replace(/-/g, '+').replace(/_/g, '/');
  const padding = normalized.length % 4;
  if (padding === 1) {
    throw new Error('invalid base64url string');
  }
  if (padding > 0) {
    normalized += '='.repeat(4 - padding);
  }
  return Uint8Array.fromBase64(normalized);
}

/**
 * Converts an array of binary data to a base64url encoded string.
 */
export function bytesToBase64URL(aBytes: Uint8Array): string {
  return bytesToBase64(aBytes).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
}

/**
 * Convert the given string to Base64. Properly handles UTF8.
 *
 * @param str
 * @returns
 */
export function strToBase64(str: string): string {
  return new TextEncoder().encode(str).toBase64();
}

/**
 * Convert the given Base64-encoded data back to a string. Properly handles UTF8.
 *
 * @param encoded
 * @returns
 */
export function base64ToStr(encoded: string): string {
  return new TextDecoder().decode(base64ToBytes(encoded));
}

export function base64URLToArrayBuffer(value: string): ArrayBuffer {
  const bytes = base64URLToBytes(value);
  const buffer = new ArrayBuffer(bytes.byteLength);
  new Uint8Array(buffer).set(bytes);
  return buffer;
}

export function arrayBufferToBase64URL(value: ArrayBuffer): string {
  return bytesToBase64URL(new Uint8Array(value));
}
